module.exports = __webpack_public_path__ + "img/LogoOficialFinerFoods-Branca.d4784f1b.png";